import React, { useState } from 'react'
import { useTableFilterContext } from './Context'
import { FilterContainerBodyLayout } from './FilterContainer'
import type { TableFilterProps } from './types'
import { ListGroup } from 'react-bootstrap'
import map from 'lodash/map'
import includes from 'lodash/includes'
import filter from 'lodash/filter'

export const ListTableFilter = ({ field }: TableFilterProps) => {
  const { onFilter, getStoredFilter } = useTableFilterContext()
  const emptyValueLabel: string | undefined = field?.fieldSettings?.emptyValueLabel
  const listItems: (string | null)[] = [...(emptyValueLabel ? [null] : []), ...(field?.fieldSettings?.listValues ?? [])]

  const initialValues = getStoredFilter()?.['$in'] ?? []
  const [selectedValues, setSelectedValues] = useState<(string | null)[]>(initialValues)

  const filterNow = () => {
    const extraFilter = { [field.name]: { $in: selectedValues } }
    onFilter(extraFilter)
  }

  const isAllSelected = selectedValues.length === listItems.length
  const onSelectAll = () => {
    if (isAllSelected) {
      setSelectedValues([])
    } else {
      setSelectedValues(listItems)
    }
  }

  return (
    <FilterContainerBodyLayout onOk={filterNow}>
      <ListGroup variant="flush">
        <ListGroup.Item onClick={onSelectAll} active={isAllSelected} action>
          {isAllSelected ? '(Unselect all)' : '(Select all)'}
        </ListGroup.Item>
        {map(listItems, (item) => {
          const isFound = includes(selectedValues, item)

          const handleSelect = () => {
            let theList = [...selectedValues]
            if (isFound) {
              //remove the item from the list
              theList = filter(theList, (e) => e !== item)
            } else {
              theList = [...theList, item]
            }
            //this will ensure that all unique string only
            const uniqueSet = Array.from(new Set(theList))
            setSelectedValues(uniqueSet)
          }

          return (
            <ListGroup.Item key={item ?? '__empty__'} action active={isFound} onClick={handleSelect}>
              {item ?? emptyValueLabel}
            </ListGroup.Item>
          )
        })}
      </ListGroup>
    </FilterContainerBodyLayout>
  )
}
